module.exports = __webpack_public_path__ + "static/media/6.3feca61f.png";